<form class="form-horizontal" #form="ngForm" (ngSubmit)="onSubmit()">

    <div class="form-group">
      <label class="control-label col-sm-3">
        {{ 'Type' | translate }}:
      </label>
      <div class="col-sm-9">
        <select class="form-control" [(ngModel)]="configType"
          (ngModelChange)="onSelectType($event)" name="type" required>
          <option [ngValue]="null">---</option>
          <option [ngValue]="1">{{ 'Programmed' | translate }}</option>
          <option [ngValue]="2">{{ 'By Connection' | translate }}</option>
          <option [ngValue]="3">{{ 'Reimburse' | translate}}</option>
        </select>
      </div>
    </div>

    <div *ngIf="configType == 1" class="form-group">
      <label class="control-label col-sm-3">
        {{ 'Programmed Date' | translate }}:
      </label>
      <div class="col-sm-9">
        <app-select-date [edittimeflag]="true" (seteditday)="onSelectday($event)"></app-select-date>
        <input style="width: unset; display: inline;" class="form-control"
          type="time" name="programtime" [(ngModel)]="programtime" (change)="onSelectTime()" required>
      </div>
    </div>

    <div *ngIf="configType == 1" class="form-group">
      <label class="control-label col-sm-3">
        {{ 'Type of programming' | translate }}:
      </label>
      <div class="col-sm-9">
        <select (change)="onSelectProgramType($event)" class="form-control" [ngModel]="program_type"
          name="program_type" required>
          <option [value]="null">-- Seleccionar --</option>
          <option *ngFor="let item of assistance_programming_types" [value]="item.id">
            {{ item.name }}
          </option>
        </select>
      </div>
    </div>

    <div class="form-group">
        <label class="control-label col-sm-3">
          {{ 'Comment' | translate }}:
        </label>
        <div class="col-sm-9">
           <textarea rows="5" cols="10" class="form-control" [(ngModel)]="comment" name="comment">
           </textarea>
        </div>
    </div>
    <div class="form-group">
      <div class="col-sm-offset-3 col-sm-9 div-btn-right">
        <button type="button" class="btn btn-default btn-sm" (click)="onCancel()">{{ 'Cancel' | translate }}</button>
        <button type="submit" class="btn btn-primary btn-sm" [disabled]="form.form.invalid || form.form.pending">
          {{ 'Create' | translate }}
        </button>
      </div>
    </div>
  </form>
